module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pagelist animate fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-sm-4 flex"
  }, [_c('div', {
    staticClass: "shadow card t-birthday"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n              วันเกิดของเราปีนี้เราขอทำสิ่งพิเศษกว่าปีที่ผ่านมา เราขอชวนพื่อนๆ มาร่วมบริจาคในโอกาสวันเกิดของเรานะ มาช่วยน้องๆ...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('funding-goal', {
    staticClass: "mb-20"
  }), _vm._v(" "), _c('button', {
    staticClass: "ma-auto btn btn--default btn--full",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ร่วมบริจาค")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-sm-4 flex"
  }, [_c('div', {
    staticClass: "shadow card t-importantday"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n              ครบรอบแต่งงานของเราปีนี้ อยากทำสิ่งที่พิเศษมากกว่าปีก่อนๆ อยากชวนเพื่อนมาร่วมบริจาคในโอกาสครบรอบแต่งงาน... ครบรอบแต่งงานของเราปีนี้ อยากทำสิ่งที่พิเศษมากกว่าปีก่อนๆ อยากชวนเพื่อนมาร่วมบริจาคในโอกาสครบรอบแต่งงา\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('funding-goal', {
    staticClass: "mb-20"
  }), _vm._v(" "), _c('button', {
    staticClass: "ma-auto btn btn--default btn--full",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ร่วมบริจาค")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-sm-4 flex"
  }, [_c('div', {
    staticClass: "shadow card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n              วันเกิดของเราปีนี้เราขอทำสิ่งพิเศษกว่าปีที่ผ่านมา เราขอชวนพื่อนๆ...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('funding-goal', {
    staticClass: "mb-20"
  }), _vm._v(" "), _c('button', {
    staticClass: "ma-auto btn btn--default btn--full",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ร่วมบริจาค")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-sm-4 flex"
  }, [_c('div', {
    staticClass: "shadow card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n              ครบรอบแต่งงานของเราปีนี้ อยากทำสิ่งที่พิเศษมากกว่าปีก่อนๆ อยากชวนเพื่อนมาร่วมบริจาคในโอกาสครบรอบแต่งงาน...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('funding-goal', {
    staticClass: "mb-20"
  }), _vm._v(" "), _c('button', {
    staticClass: "ma-auto btn btn--default btn--full",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ร่วมบริจาค")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-sm-4 flex"
  }, [_c('div', {
    staticClass: "shadow card t-birthday"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n              วันเกิดของเราปีนี้เราขอทำสิ่งพิเศษกว่าปีที่ผ่านมา เราขอชวนพื่อนๆาช่วยน้องๆ...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('funding-goal', {
    staticClass: "mb-20"
  }), _vm._v(" "), _c('button', {
    staticClass: "ma-auto btn btn--default btn--full",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ร่วมบริจาค")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-sm-4 flex"
  }, [_c('div', {
    staticClass: "shadow card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n              ครบรอบแต่งงานของเราปีนี้ อยากทำสิ่งที่พิเศษมากกว่าปีก่อนๆ อยากชวนเพื่อนมาร่วมบริจาคในโอกาสครบรอบแต่งงาน...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('funding-goal', {
    staticClass: "mb-20"
  }), _vm._v(" "), _c('button', {
    staticClass: "ma-auto btn btn--default btn--full",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ร่วมบริจาค")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-sm-4 flex"
  }, [_c('div', {
    staticClass: "shadow card t-importantday"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n              วันเกิดของเราปีนี้เราขอทำสิ่งพิเศษกว่าปีที่ผ่านมา เราขอชวนพื่อนๆ มาร่วมบริจาคในโอกาสวันเกิดของเรานะ มาช่วยน้องๆ...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('funding-goal', {
    staticClass: "mb-20"
  }), _vm._v(" "), _c('button', {
    staticClass: "ma-auto btn btn--default btn--full",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("ร่วมบริจาค")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-pagelist"
  }, [_c('h1', {
    staticClass: "header-title text-center"
  }, [_vm._v("โอกาสพิเศษที่อยากให้คุณมีส่วนร่วม")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-title text-center"
  }, [_vm._v("ร่วมบริจาคในโอกาสพิเศษและให้โอกาสทางการศึกษาแก่เด็กด้อยโอกาสไปพร้อมกัน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../assets/img/profile-mockup.png"),
      "alt": "people"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Happy Birthday")]), _vm._v(" "), _c('div', [_vm._v("เฌอปรางค์ อารีย์กุล"), _c('br'), _vm._v("1 มกราคม ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../assets/img/profile-mockup.png"),
      "alt": "people"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Happy Anniversary")]), _vm._v(" "), _c('div', [_vm._v("อรุณา & วริศ"), _c('br'), _vm._v("31 มกราคม ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "background-image": "url('/static/img/image-preset-event/bg-preset-03@2x.png')"
    }
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../assets/img/profile-mockup.png"),
      "alt": "people"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Happy Time")]), _vm._v(" "), _c('div', [_vm._v("เฌอปรางค์ อารีย์กุล")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "background-image": "url('/static/img/image-preset-event/bg-preset-04@2x.png')"
    }
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../assets/img/profile-mockup.png"),
      "alt": "people"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Happy Anniversary")]), _vm._v(" "), _c('div', [_vm._v("มะนาว นะคะ"), _c('br'), _vm._v("31 มกราคม ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../assets/img/profile-mockup.png"),
      "alt": "people"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Happy Birthday")]), _vm._v(" "), _c('div', [_vm._v("เฌอปรางค์ อารีย์กุล"), _c('br'), _vm._v("1 มกราคม ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "background-image": "url('/static/img/image-preset-event/bg-preset-05@2x.png')"
    }
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../assets/img/profile-mockup.png"),
      "alt": "people"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Happy Anniversary")]), _vm._v(" "), _c('div', [_vm._v("อรุณา & วริศ"), _c('br'), _vm._v("31 มกราคม ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../assets/img/profile-mockup.png"),
      "alt": "people"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Happy Aniversary")]), _vm._v(" "), _c('div', [_vm._v("เฌอปรางค์ อารีย์กุล"), _c('br'), _vm._v("1 มกราคม ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5163f64","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageList.vue
// module id = 1125
// module chunks = 1